export const getRole = () =>
	sessionStorage.getItem('role') || localStorage.getItem('role') || 'none'
